module.exports = {
	rpp: 20,
	basicLists: {
		dashCounters: {
			families: { title: 'Семейства', icon: 'fa-users', link: '/family/list' },
			children: { title: 'Домашни ученици', icon: 'fa-send-o', link: '/family/list' },
			discussions: { title: 'Дискусии', icon: 'fa-comments', link: '/discussion/list' }
		},

		resourceTypes: {
			books: { title: 'Книги', icon: 'fa-book', link: '/book/list' },
			materials: { title: 'Учебни материали', icon: 'fa-leanpub', link: '/material/list' },
			links: { title: 'Връзки', icon: 'fa-link', link: '/link/list' }
		},

		eventTypes: {
			'new-family': { text: 'се присъедини към Семейна образователна мрежа', icon: 'fa-users', link: '', color: 'danger' },
			'new-book': { text: 'добави нова книга', icon: 'fa-book', link: '/book/', color: 'success' },
			'new-material': { text: 'добави нов учебен материал', icon: 'fa-leanpub', link: '/material/', color: 'primary' },
			'new-link': { text: 'добави нова връзка', icon: 'fa-link', link: '/link/', color: 'warning' }
		},

		menuItems: {
			dashboard: { title: 'Начало', icon: 'fa-home', link: '/', comment: 'Начален екран с обобщена информация за семействата и ресурсите' },
			family: { title: 'Нашето семейство', icon: 'fa-user', link: '/family/me', comment: 'На този екран може да представите накратко Вашето семейство, за да могат останалите семейства да се свържат с вас.' },
			families: { title: 'Семейства', icon: 'fa-users', link: '/family/list', comment: 'Списък със семействата в Семейната образователна мрежа' },
			books: { title: 'Книги', icon: 'fa-book', link: '/book/list', comment: 'Информация за книги и учебници (печатни материали), предоставяни от различни семейства. Материалите могат да бъдат заемани от други семейства за определен срок.' },
			materials: { title: 'Учебни материали', icon: 'fa-tasks', link: '/material/list', comment: 'Онлайн учебни материали (Google документи/файлове), споделяни или създавани от семействата в мрежата. Достъпът до тези материали е ограничен и всяко семейство решава на кого да разреши достъп до тях.' },
			links: { title: 'Връзки', icon: 'fa-link', link: '/link/list', comment: 'В тази секция публикуваме връзки към полезни сайтове, които сме използвали. Моля, не публикувайте връзки към сайтове, които са ви харесали, но не използвате реално.' },
			discussions: { title: 'Дискусии', icon: 'fa-comments', link: '/discussion/list', comment: 'Дискусии по различни теми.' },
			events: { title: 'История', icon: 'fa-clock-o', link: '/events', comment: 'Списък на последните събития в мрежата.' }
		}
	},

	lists: {
		languages: {
			'BG': { text: 'Български' },
			'EN': { text: 'English' },
			'RU': { text: 'Русский' },
			'ES': { text: 'Espaniol' },
			'FR': { text: 'Français' },
			'GE': { text: 'Deutsche' }
		},
		bookStatuses: {
			'available': { text: 'Налична', style: 'success', selectable: true },
			'requested': { text: 'Поискана', style: 'warning', selectable: false },
			'taken': { text: 'Заета', style: 'danger', selectable: true },
			'unavailable': { text: 'Не e налична', style: 'unavailable', selectable: true }
		},

		familyRoles: {
			'father': { text: 'Баща', placeholder: 'Иван' },
			'mother': { text: 'Майка', placeholder: 'Мария' }
		},

		childRoles: {
			'son': { text: 'Син' },
			'daughter': { text: 'Дъщеря' }
		},

		countries: {
			'BG': { text: 'България' }
		},

		states: {
			'1': { text: 'Благоевград', code: 'Бл' },
			'2': { text: 'Бургас', code: 'Бс' },
			'3': { text: 'Варна', code: 'Вн' },
			'4': { text: 'Велико Търново', code: 'ВТ' },
			'5': { text: 'Видин', code: 'Вд' },
			'6': { text: 'Враца', code: 'Вр' },
			'7': { text: 'Габрово', code: 'Гб' },
			'8': { text: 'Добрич', code: 'Дб' },
			'9': { text: 'Кърджали', code: 'Кж' },
			'10': { text: 'Кюстендил', code: 'Кн' },
			'11': { text: 'Ловеч', code: 'Лч' },
			'12': { text: 'Монтана', code: 'Мн' },
			'13': { text: 'Пазарджик', code: 'Пз' },
			'14': { text: 'Перник', code: 'Пк' },
			'15': { text: 'Плевен', code: 'Пл' },
			'16': { text: 'Пловдив', code: 'Пд' },
			'17': { text: 'Разград', code: 'Рз' },
			'18': { text: 'Русе', code: 'Рс' },
			'19': { text: 'Силистра', code: 'Сс' },
			'20': { text: 'Сливен', code: 'Сл' },
			'21': { text: 'Смолян', code: 'См' },
			'22': { text: 'Софийска област', code: 'СО' },
			'23': { text: 'София', code: 'Сф' },
			'24': { text: 'Стара Загора', code: 'СЗ' },
			'25': { text: 'Търговище', code: 'Тщ' },
			'26': { text: 'Хасково', code: 'Хс' },
			'27': { text: 'Шумен', code: 'Шм' },
			'28': { text: 'Ямбол', code: 'Яб' }
		},
		socialNetworks: {
			'blog': { text: 'Blog' },
			'facebook': { text: 'Facebook' },
			'twitter': { text: 'Twitter' },
			'linkedin': { text: 'LinkedIn' },
			'googleplus': { text: 'Google+' },
			'youtube': { text: 'YouTube' },
			'instagram': {text: 'Instagram'},
			'pinterest': {text: 'Pinterest'},
			'tumblr': {text: 'Tumblr'},
			'reddit': {text: 'Reddit'},
			'flickr': {text: 'Flickr'}
		},
		hsmethods: {
			'traditional': { name: 'Традиционен метод', desc: 'Най-много наподобява училищния подход. Използва се готова учебна програма, като родителите я променят според темпото, с което детето учи.' },
			'trivium': { name: 'Класически метод (Тривиум)', desc: 'Три етапа: Граматика (6-10 г., запомнят информация, разбират и запомнят правила), Логика (10-12 г., учат се да мислят логично в различните области на познанието), Риторика (гимназиална възраст, учат се да изразяват себе си писмено и устно).' },
			'unit_studies': { name: 'Тематични уроци (Unit Studies)', desc: 'Дадена тема се разглежда чрез различни учебни предмети и дисциплини. По този начин информацията не се представя на децата дефрагментирано, а като едно цяло.' },
			'unschooling': { name: 'Неучилищен метод (ънскулинг)', desc: 'Естествено, водено от децата и техните интереси образование. Децата не следват предварително зададена училищна програма или формални уроци.' },
			'charlotte_mason': { name: 'Метод на Шарлот Мейсън', desc: 'Шарлот Мейсън (1842-1923 г.) препоръчва изучаването на история, география и литература да става чрез четене на „живи книги“, чийто автор има истински интерес към темата и пише увлекателно, за разлика от един учебник, който дава безлична и фрагментирана информация по много теми. Живите книги представят вдъхновяваши истории и герои, които вълнуват умовете на деца. Методът на Мейсън препоръчва разходки сред природата, вдъхновяващи занимания с изкуството и музиката.' },
			'eclectic': { name: 'Избирателен метод (Eclectic)', desc: 'Комбиниране на различни методи на обучение по различните предмети.' },
			'distance_school': { name: 'Дистанционно училище', desc: 'Учене по програма, предоставена от дистанционно училище.' }
		},

		categoryScopes: {
			'all': { text: 'по всички екрани' },
			'forum': { text: 'само във Форуми' },
			'lesson': { text: 'само в Учебни материали' }
		},

		sectionColors: {
			'#6add2c': { text: 'Зелен' },
			'#e3412b': { text: 'Червен' },
			'#3552eb': { text: 'Син' },
			'#e9e344': { text: 'Жълт' },
			'#b93dde': { text: 'Лилав' },
			'#36dddd': { text: 'Светлосин' },
			'#212421': { text: 'Черен' },
			'#8a8889': { text: 'Сив' },
			'#e5e6e4': { text: 'Бял' },
		},

		borrowPeriods: [
			{value: 3, label: '3 месеца'},
			{value: 6, label: '6 месеца'},
			{value: 9, label: '9 месеца'},
			{value: 12, label: '12 месеца'}
		]
		/*
		hsReasons: [
			{ text: 'Имам възможност да прекарвам повече време с децата си и да бъда с тях, когато се оформят като личности.' },
			{ text: 'Имаме свобода да учим нещата, които считаме за необходими.' },
			{ text: 'Мога да отделям индивидуално внимание и да им дам по­-добра подготовка.' },
			{ text: 'Избрах го по религиозни причини.' },
			{ text: 'Избрах го заради по­-добрата социализация.' },
			{ text: 'Искам да подготвя децата си да бъдат конкурентни на трудовия пазар.' },
			{ text: 'Не ми харесват постоянните хаотични промени в училищното образование.' },
			{ text: 'Не ми харесва дисциплината в училищата.' },
			{ text: 'Не ми харесва насилието в училищата.' },
			{ text: 'Не ми харесват учебниците в училищата.' },
			{ text: 'Не ми харесва програмата в училищата.' },
			{ text: 'Не ми харесва подготовката/подходът на учителите в училищата.' }
		]
*/
	}
};



// WEBPACK FOOTER //
// ./src/cfg/common.js